import { render } from "./ExerciseDisplay.vue?vue&type=template&id=75505ddc"
import script from "./ExerciseDisplay.vue?vue&type=script&lang=js"
export * from "./ExerciseDisplay.vue?vue&type=script&lang=js"

import "./ExerciseDisplay.vue?vue&type=style&index=0&id=75505ddc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__